import translations from './translations'
import config from '../../config'
const defaultState = {
    currentLocale: config.DefaultLocale || 'en-US',
    locales: {'bg': 0,'en-US': 1},
    translations
}

export default (state=defaultState, action) => {
    switch(action.type) {
        case 'SET_LOCALE': {
            localStorage.setItem('locale', action.payload)
            return {...state, currentLocale:action.payload}
        }
        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/modules/Translations/reducer.js